import React from "react";

import GridCellCropped from "@/components/Grid/Cell/Cropped";
import useBlockScanAddress from "@/hooks/useBlockScanAddress";

import { SupLoader, SupText } from "@repo/core-ui";
import { SupChain } from "@repo/core-ui";
import { twMerge } from "tailwind-merge";

interface UiLabelChainScanLinkProps {
  address: string;
  chain: number;
  urlLabel?: string;
  prefixLabel?: string;
  uncutAddress?: boolean;
}

export default function UiLabelChainScanLink({ address, chain, urlLabel = "Explorer", prefixLabel = "View on", uncutAddress = false }: UiLabelChainScanLinkProps) {
  const { url, isLoading } = useBlockScanAddress({
    address,
    chain: Number(chain),
  });

  return isLoading ? (
    <SupLoader isSmall />
  ) : url !== undefined ? (
    <a
      href={url}
      target="_blank"
      className="linkstyle group inline-flex items-center whitespace-nowrap font-light text-neutral-900 decoration-from-font lg:font-normal"
      rel="noopener noreferrer"
    >
      {urlLabel && (
        <SupText variant="subtitle2">
          {prefixLabel}&nbsp;{urlLabel}&nbsp;
        </SupText>
      )}
      <code className="select-none flex-row whitespace-nowrap rounded-lg bg-[transparent] p-0 font-mono text-sm tracking-tighter md:group-hover:text-neutral-700 lg:text-xs">
        <span>{address.substring(0, 7)}</span>
        {uncutAddress && <span className="hidden lg:inline-flex">{address.slice(7, address.length - 6)}</span>}
        <span className={twMerge(uncutAddress && "inline-flex lg:hidden")}>...</span>
        <span>{address.slice(-5)}</span>
      </code>
      <SupChain className="ml-.5 h-4 stroke-0 text-neutral-900 md:group-hover:text-neutral-700" />
    </a>
  ) : (
    <div className="flex items-center space-x-2 pl-2">
      <SupText variant="subtitle2">TX Hash:</SupText>
      <GridCellCropped as="code" className="text-neutral-900" value={address} front={7} back={5} showCopy />
    </div>
  );
}
